import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { WhatIfAction } from "./Action/WhatIfAction";
import { AddEditRegularWithdrawals } from "./Components/AddEditRegularWithdrawals";
import { AddOneOffWithdrawal } from "./Components/AddOneOffWithdrawal";
import { AdHocAdviserCharges } from "./Components/AdHocAdviserCharges";
import { ChangesToTheModel } from "./Components/ChangesToTheModel";
import { ClientDetailsForWhatIf } from "./Components/ClientDetails";
import { EditAdviserCharges } from "./Components/EditAdviserCharges";
import { EditInvestmentSelection } from "./Components/EditInvestmentSelection";
import { EditPaymentsIn } from "./Components/EditPaymentsIn";
import { Review } from "./Components/Review";
import { stepTitle, whatifProcess } from "./Resource/Contents";
import { WhatIfToolStore } from "./Store/Variable";
import { processTypeEnum } from "../Common/Resource/Contents"
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { SPTAction } from "../SinglePaymentTransferWizard/Actions/SPTActions";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { PensionArrangement } from "../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { SubAccountTypeHelper } from "../Common/Helpers/SubAccountTypeHelper";
import { PensionOption } from "../../../../../Wrap/Constants/Enums/Apply/PensionOption";
// Comment out for R64 in SLP-174563, to be fixed post R64
//import { ConvertCappedToFlexi } from "./Components/ConvertCappedToFlexi/ConvertCappedToFlexi";
/*TPB*/
import { PensionBenefitsDetails } from "./Components/TakePensionBenefits/PensionBenefitsDetails";
import { IncomePaymentDetails as TPBIncomePaymentDetails } from "./Components/TakePensionBenefits/IncomePaymentDetails";
/*Edit income drawdown*/
import { DrawdownDetails as EditIncomeDrawdown } from "./Components/EditIncomeDrawdown/DrawdownDetails";
import { IncomePaymentDetails as EditIncomeDrawdownIncomePaymentDetails } from "./Components/EditIncomeDrawdown/IncomePaymentDetails";
/*Edit income payment*/
import { IncomePaymentDetails as EditIncomePayment } from "./Components/EditIncomePayments/IncomePaymentDetails";
/*One off income payment*/
import { IncomePaymentOneOffDetail } from "./Components/OneOffIncomePayment/IncomePaymentOneOffDetail";
import { RegularDrawdown } from "../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { GetRegularCrystallisationAction } from "../CancelRegularCrystallisationWizard/Actions/GetRegularCrystallisationAction";
import { PensionArrangementType } from "../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { CappedPensionArrangementsFlexiConversionAvailability } from "../../../../../Wrap/Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionAvailability";
import { isNullOrEmpty } from "../../../../../react-core/Utils/Arrays";
import { TransferType } from "../../../../../Wrap/Constants/Enums/Domain/TransferType";


interface IWhatIfToolWizardState extends IAccountContextWizardComponentState {
    extraInfo?: any;
    pensionArrangements: PensionArrangement[];
    cappedPensionArrangementsFlexiConversions?: CappedPensionArrangementsFlexiConversionAvailability[];
    regularDrawdown?: RegularDrawdown;
    firstFlag: boolean;
}

export class WhatIfToolWizard extends AccountContextWizardComponent<IWhatIfToolWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
            pensionArrangements: [],
            firstFlag: true
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(WhatIfToolStore, () => this.onInstructionStoreChange());
    }

    componentDidUpdate(prevProps) {
        const params = getQueryParameters();
        const { clientAccount, customer, firstFlag } = this.state;
        if (clientAccount && customer && !this.state.data && firstFlag) {
            this.setState({ firstFlag: false });
            WhatIfAction.getInstruction(
                params["id"],
                params["hierarchyid"],
                params["subaccounthierarchyid"],
                customer.CustomerId,
                this.getCurProductType(),
                params["batchid"]
            );

            const productType = this.getCurProductType();
            const subaccountHierarchyId = params["subaccounthierarchyid"];
            if (SubAccountTypeHelper.isOnPlatformPension(productType) && this.state.pensionArrangements.length == 0) {
                // todo - the below part will need to add into a combined controller, after arrangement progress finished
                WhatIfAction.getPensionArrangementDetails(subaccountHierarchyId, false, (data) => {
                    this.setState({ pensionArrangements: data });
                    if (WhatIfAction.getActiveRetirementArrangementsByType(data, PensionArrangementType.Capped)) {
                        WhatIfAction.getCappedArrangementDetails(subaccountHierarchyId, (result) => {
                            this.setState({ cappedPensionArrangementsFlexiConversions: result });
                        })
                    }

                })

                const hierarchyId = getQueryParameters()["hierarchyid"];
                GetRegularCrystallisationAction.getRegularCrystallisation(hierarchyId, (result) =>
                    this.setState({ regularDrawdown: result })
                );
            }

        }
    }

    onInstructionStoreChange() {
        const data = WhatIfToolStore.getData();
        this.setState({
            isLoading: CommonHelper.isNullOrEmpty(data) || Object.keys(this.state.extraInfo || {}).length === 0,
            data: data,
            onPosting: false,
            active: data.Status === InstructionStatus.Pending || data.Status === InstructionStatus.NotSpecified,
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        WhatIfAction.getPrepopulateData(
            params["subaccounthierarchyid"],
            params["hierarchyid"],
            params["batchid"],
            (info) => {
                this.setState({
                    extraInfo: info,
                    isLoading: CommonHelper.isNullOrEmpty(this.state.data) || CommonHelper.isNullOrEmpty(info),
                });
            }
        );


    }

    onSubmit() { }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            SPTAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                ProcessType.WhatIfTool
            );
        }
        if (to < stepLength - 1) {
            WhatIfAction.saveInstruction(from, this.state.data, this.getCurProductType(), this.state.customer.CustomerId, (result) => {
                this.setState({ onPosting: false });
                if (result?.length > 0) {
                    this.setState({
                        errorMsg: result,
                        isShowErrorMsg: true,
                    });
                } else {
                    if (to == -1) {
                        this.onExit();
                    } else {
                        Navigator.navigateTo(toUrl, {
                            queryParamsObject: {
                                ...params,
                                id: WhatIfToolStore.getData()?.HierarchyId,
                            },
                            scrollAfterNavigating: true,
                        });
                    }
                }
            });
        } else {
            WhatIfAction.saveInstruction(from, this.state.data, this.getCurProductType(), this.state.customer.CustomerId, (result) => {
                WhatIfAction.submitInstruction(this.state.data?.HierarchyId, () => {
                    this.setState({
                        isSubmitting: false,
                        onPosting: false,
                        active: false,
                        isShowErrorMsg: false,
                        errorMsg: [],
                    });
                    if (to == -1) {
                        this.onExit();
                    } else {
                        Navigator.navigateTo(toUrl, {
                            queryParamsObject: {
                                ...params,
                                id: WhatIfToolStore.getData()?.HierarchyId,
                            },
                            scrollAfterNavigating: true,
                        });
                    }
                });
            });
        }
    }

    onCancel() {
        // WhatIfAction.deleteInstruction(WhatIfToolStore.getData()?.HierarchyId, () => this.onExit());
        this.onExit();
    }

    onExit() {
        const query = getQueryParameters();
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    private getCurProductType(): SubAccountType {
        const clientInfo = ClientAccountStore.getClientAccountInfo();
        const params = getQueryParameters();
        const productType = (clientInfo.SubAccounts || []).find(
            (ele) => ele.HierarchyId == params["subaccounthierarchyid"]
        )?.SubAccountType;
        return productType;
    }

    getStepProps(index) {
        const stepProps = super.getStepProps(index);
        return stepProps;
    }

    setStepperConfig() {
        const productType = this.getCurProductType();
        const { data } = this.state;
        const selectedModel = (data?.Contribution?.ChangesToBeModeled || "").split(",");
        this.stepperConfig = [
            {
                title: stepTitle.ChangesToBeModelled,
                url: Urls.get().WhatIfToolChangesModel,
                path: Contents.URLMap.wrapperSelection,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <ChangesToTheModel {...this.getStepProps(0)} type={productType} extraInfo={this.state.extraInfo} pensionArrangements={this.state.pensionArrangements} regularDrawdown={this.state.regularDrawdown} />
                ),
            },
            {
                title: stepTitle.ClientDetails,
                url: Urls.get().WhatIfToolClientDetail,
                path: Contents.URLMap.clientDetails,
                component: <ClientDetailsForWhatIf {...this.getStepProps(1)} extraInfo={this.state.extraInfo} />,
            },
        ];

        // Group the changes to be modelled under current product
        const subaccounthierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const subAccount = ClientAccountStore.getClientAccountInfo()?.SubAccounts.find(
            (acc) => acc.HierarchyId === subaccounthierarchyId
        );
        const productName = subAccount?.ProductDisplayName;
        if (selectedModel.includes(whatifProcess.editPaymentIn)) {
            this.stepperConfig.push({
                title: stepTitle.EditPaymentIn,
                url: Urls.get().WhatIfToolPaymentsIn,
                path: Contents.URLMap.paymentIn,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <EditPaymentsIn {...this.getStepProps(this.stepperConfig.length)} type={productType} subaccountHierarchyId={subaccounthierarchyId} />,
            });
        }
        if (selectedModel.includes(whatifProcess.editAdviserCharges)) {
            this.stepperConfig.push({
                title: stepTitle.EditAdviserCharges,
                url: Urls.get().WhatIfToolAdviserCharge,
                path: Contents.URLMap.adviserCharges,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <EditAdviserCharges {...this.getStepProps(this.stepperConfig.length)} type={productType} />,
            });
        }
        if (selectedModel.includes(whatifProcess.AddAdditionalAdviserCharge)) {
            this.stepperConfig.push({
                title: stepTitle.AddAdditionAdviserCharges,
                url: Urls.get().WhatIfToolAdHocCharge,
                path: Contents.URLMap.adHocAdviserCharge,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <AdHocAdviserCharges
                        {...this.getStepProps(this.stepperConfig.length)}
                        type={productType}
                        extraInfo={this.state.extraInfo}
                    />
                ),
            });
        }
        if (this.showEditInvestmentSelection(selectedModel, this.state.data?.Contribution)) {
            this.stepperConfig.push({
                title: stepTitle.editInvestmentSeletion,
                url: Urls.get().WhatIfToolInvestmentSelection,
                path: Contents.URLMap.ist,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <EditInvestmentSelection
                        {...this.getStepProps(this.stepperConfig.length)}
                        type={productType}
                        extraInfo={this.state.extraInfo}
                    />
                ),
            });
        }
        if (selectedModel.includes(whatifProcess.AddEditRegularWithdrawals)) {
            this.stepperConfig.push({
                title: stepTitle.addEditRegularWithdrawals,
                url: Urls.get().WhatIfToolRegularWithdrawal,
                path: Contents.URLMap.regularWithdrawals,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <AddEditRegularWithdrawals
                        {...this.getStepProps(this.stepperConfig.length)}
                        type={productType}
                        extraInfo={this.state.extraInfo}
                    />
                ),
            });
        }
        if (selectedModel.includes(whatifProcess.AddOneOffWithdrawal)) {
            this.stepperConfig.push({
                title: stepTitle.addOneOffWithdrawal,
                url: Urls.get().WhatIfToolOneOffWithdrawal,
                path: Contents.URLMap.oneOffWithdrawal,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <AddOneOffWithdrawal
                        {...this.getStepProps(this.stepperConfig.length)}
                        type={productType}
                        extraInfo={this.state.extraInfo}
                    />
                ),
            });
        }
        // Comment out for R64 in SLP-174563, to be fixed post R64
        /*
        if (selectedModel.includes(whatifProcess.ConvertCappedToFlexi)) {
            this.stepperConfig.push({
                title: stepTitle.convertCappedToFlexi,
                url: Urls.get().WhatIfToolConvertCappedToFlexi,
                path: Contents.URLMap.convertCappedToFlexi,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <ConvertCappedToFlexi {...this.getStepProps(this.stepperConfig.length)} cappedPensionArrangementsFlexiConversions={this.state.cappedPensionArrangementsFlexiConversions ?? []} />
                ),
            });
        }
        */

        if (selectedModel.includes(whatifProcess.TakePensionBenefits)) {
            this.stepperConfig.push({
                title: stepTitle.takePensionBenefits,
                url: Urls.get().WhatIfToolTakePensionBenefits,
                path: Contents.URLMap.pensionBenefitsDetails,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <PensionBenefitsDetails {...this.getStepProps(this.stepperConfig.length)} type={productType} customerId={this.state.customer.CustomerId} />
                ),
            });

            if (
                this.state.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
                (this.state.data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId == null ||
                (this.state.data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId && this.state.data?.Contribution?.DrawdownModel?.TaxFreeLumpSum?.Amount > 0))
            ) {
                this.stepperConfig.push({
                    title: "Benefits - " + stepTitle.incomePaymentDetails,
                    url: Urls.get().WhatIfToolTPBIncomePaymentDetails,
                    path: Contents.URLMap.pensionBenefitsIncomePayment,
                    group: productName,
                    onStepLeave: (from, to) => {
                        this.onStepperLeave(from, to);
                    },
                    component: <TPBIncomePaymentDetails {...this.getStepProps(this.stepperConfig.length)} type={productType} />,
                });
            }
        }

        if (selectedModel.includes(whatifProcess.EditIncomeDrawdown)) {
            this.stepperConfig.push({
                title: stepTitle.editIncomeDrawdown,
                url: Urls.get().WhatIfToolEditIncomeDrawdown,
                path: Contents.URLMap.editIncomeDrawdown,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <EditIncomeDrawdown {...this.getStepProps(this.stepperConfig.length)} />
                ),
            });

            this.stepperConfig.push({
                title: "Drawdown - " + stepTitle.incomePaymentDetails,
                url: Urls.get().WhatIfToolEditIncomeDrawdownIncomePayment,
                path: Contents.URLMap.whatifEditDrawdownIncomePayment,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <EditIncomeDrawdownIncomePaymentDetails {...this.getStepProps(this.stepperConfig.length)} />
                ),
            });
        }

        if (selectedModel.includes(whatifProcess.EditIncomePayments)) {
            this.stepperConfig.push({
                title: stepTitle.editIncomePayments,
                url: Urls.get().WhatIfToolEditIncomePayments,
                path: Contents.URLMap.editIncomePayments,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <EditIncomePayment {...this.getStepProps(this.stepperConfig.length)} extraInfo={this.state.extraInfo} processType={processTypeEnum.EditIncomePayments} isLoading={this.state.isLoading} />
                ),
            });
        }

        if (selectedModel.includes(whatifProcess.SIPPOneOffIncomePayment)) {
            this.stepperConfig.push({
                title: stepTitle.sIPPOneOffIncomePayment,
                url: Urls.get().WhatIfOneOffIncomePayment,
                path: Contents.URLMap.incomePaymentOneOff,
                group: productName,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <IncomePaymentOneOffDetail {...this.getStepProps(this.stepperConfig.length)} customerId={this.state.customer.CustomerId} />
                ),
            });
        }

        this.stepperConfig.push({
            title: stepTitle.review,
            url: Urls.get().WhatIfToolReview,
            path: Contents.URLMap.review,
            needPrint: true,
            component: <Review {...this.getStepProps(this.stepperConfig.length)} type={productType} cappedPensionArrangementsFlexiConversions={this.state.cappedPensionArrangementsFlexiConversions ?? []} />,
        });
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "What if tool";
        return processProps;
    }

    private showEditInvestmentSelection(selectedModel, contribution): boolean {
        if (selectedModel.includes(whatifProcess.editInvestmentSeletion)) {
            var subAccountType = this.getCurProductType();
            var transfers = contribution?.[this.getTransfersType(subAccountType)];
            if (subAccountType == SubAccountType.Npr && !isNullOrEmpty(transfers)) {
                if (transfers.every(x => x.TransferType == TransferType.InSpecie)) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    private getTransfersType = (type) => {
        if (SubAccountTypeHelper.isPP(type)) {
            return "GiaTransfers";
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return "IsaTransfers";
        } else {
            return "PensionTransfers";
        }
    };
}
